import 'waypoints';
import 'jquery.animate-number';
import 'slick-carousel';
import './scroll.js';
import './slider.js';
import './animate_numbers.js';
import './tabs.js';
import './accordions.js';
import './shuffle.js';
import './navbar';


